module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp2_7005.b3ec6e48.png";